import propTypes from "prop-types"
import { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader, Alert } from "reactstrap"
import { useMutation } from "@tanstack/react-query"
import { updateLimitForCashCut } from "services/periodic-tasks"
import { updateCashCounterRegister, addCashMovemnts } from "services/tickets"
import Swal from "sweetalert2"
import { Loading } from "components"
import CashRegisterForm from "./cash-register-form "

const EditModalFormCashRegister = ({
  isOpen,
  toggle,
  setShowAlertSuccess,
  setMsgSuccess,
  cashCounterRegister,
  data,
  error,
  isLoading,
  isError,
  limitId,
  refetch,
}) => {
  const {
    isLoading: isLoadingEdit,
    isError: isErrorEdit,
    error: errorEdit,
    isSuccess: isSuccessEdit,
  } = useMutation(["limit-cash-cut", limitId], (data) => updateLimitForCashCut(limitId, data))

  // const submit = async (data) => {
  //   const dataTemp = { ...data }
  //   dataTemp.limit = parseFloat(dataTemp.limit.replace(/,/g, ""))
  //   await mutateAsync({ ...dataTemp })
  // }
  const [cashInRegister, setCashInRegister] = useState()

  const submit = async () => {
    if (cashCounterRegister.cash - cashInRegister >= 0) {
      await updateCashCounterRegister(cashCounterRegister.id, {
        cash: cashCounterRegister.cash - cashInRegister,
      })
      await addCashMovemnts({
        cash: cashInRegister,
        user: cashCounterRegister.user,
      })
      setMsgSuccess("Efectivo retirado satisfactoriamente")
      setShowAlertSuccess(true)
      refetch()
      toggle()
    }
    Swal.fire({
      title: "Cantidad invalida",
      text: "La cantidad que quieres retirar es mayor a la que existe.",
      confirmButtonColor: "#6fc33a",
      icon: "error",
    })
  }

  useEffect(() => {
    if (isSuccessEdit) {
      setMsgSuccess("Efectivo retirado satisfactoriamente")
      setShowAlertSuccess(true)
      refetch()
      toggle()
    }
  }, [isSuccessEdit, submit])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Retirar efectivo de la caja resgistradora
      </ModalHeader>
      <ModalBody>
        {isLoading && (
          <div className="text-center">
            <Loading isLoading={isLoading} size={2} />
          </div>
        )}
        {isError && (
          <div className="text-center">
            <Alert color="danger" isOpen={isError}>
              {error?.errors?.map((error) => error?.message)}
            </Alert>
          </div>
        )}
        {!isLoading && !isError && (
          <CashRegisterForm
            submit={submit}
            toggle={toggle}
            isLoading={isLoadingEdit}
            isError={isErrorEdit}
            error={errorEdit}
            data={data}
            cashCounterRegister={cashCounterRegister}
            setCashInRegister={setCashInRegister}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

EditModalFormCashRegister.defaultProps = {
  taskId: null,
}

EditModalFormCashRegister.propTypes = {
  isOpen: propTypes.bool,
  toggle: propTypes.func,
  setShowAlertSuccess: propTypes.func,
  setMsgSuccess: propTypes.func,
  cashCounterRegister: propTypes.object,
  data: propTypes.object,
  error: propTypes.any,
  isLoading: propTypes.bool,
  isError: propTypes.bool,
  limitId: propTypes.any,
  refetch: propTypes.func,
}

export default EditModalFormCashRegister
